/**
 *
 * BootGate
 *
 */

import { useContext, useLayoutEffect } from 'react';

import { BootContext } from '.';

function BootGate() {
  const boot = useContext(BootContext);

  useLayoutEffect(() => {
    if (!boot) return undefined;

    return boot.acquire();
  }, [boot]);

  return null;
}

export default BootGate;
